let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("isXId")).then(() => parcelRequire('29qD5'));